import { render, staticRenderFns } from "./ClienteVoci.vue?vue&type=template&id=59454e1a"
import script from "./ClienteVoci.vue?vue&type=script&lang=js"
export * from "./ClienteVoci.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports